import http from '../const/http-common'

const getGroups = (groupInfo) => {
  return http.post('/v1/group/get-list', groupInfo);
}

const createGroup = (groupInfo) => {
  return http.post('/v1/group/create', groupInfo);
}

const updateGroup = (groupInfo) => {
  return http.post('/v1/group/update', groupInfo);
}
const deleteGroup = (id) => {
  return http.delete(`/v1/group/${id}/delete`);
}

const assignSourceToGroup = (info) => {
  return http.post(`/v1/group/assign_db`, info);
}

const assignUserToGroup = (info) => {
  return http.post(`/v1/group/assign_user`, info);
}

const getSources = (info) => {
  return http.post(`/v1/group/get_sources`, info);
}

const getUsers = (info) => {
  return http.post(`/v1/group/get_users`, info);
}

const userService = {
  getGroups,
  createGroup,
  updateGroup,
  deleteGroup,
  assignSourceToGroup,
  assignUserToGroup,
  getSources,
  getUsers
}

export default userService